import { Box, Flex } from '@chakra-ui/react';
import { Button } from '@foam/buoy/src/components/Button/Button';
import { Feature } from '~/components/Feature';
import { ManagerDropdown } from '~/components/ManagerDropdown';
import {
  CreatorProfileDropdownMenu,
  RosterViewDropdownMenu,
} from '~/components/TalentDropdownMenu';
import { FEATURE_FLAGS } from '~/constants';
import { ICreator, ManagerShortType } from '~/types';

interface Props {
  creator: ICreator;
  isProfile?: boolean;
  isShared: boolean | undefined;
  note?: string;
  onNoteOpen?: () => void;
  onRemoveFromList?: (creator: ICreator) => void | Promise<void>;
  onMessageOpen?: (creator: ICreator) => void;
}

export const CreatorButtons: React.FC<Props> = ({
  creator,
  isProfile, // from Creator Profile page
  isShared,
  note,
  onNoteOpen,
  onRemoveFromList,
  onMessageOpen,
}) => (
  <Flex justify="wrap" alignItems="center">
    <Box marginRight="auto" gap={4} display="flex">
      {!isShared ? (
        isProfile ? (
          <CreatorProfileDropdownMenu
            creator={creator}
            note={note}
            onNoteOpen={onNoteOpen}
            isShared={isShared}
          />
        ) : (
          <RosterViewDropdownMenu
            creator={creator}
            isShared={isShared}
            note={note}
            onNoteOpen={onNoteOpen}
            onRemoveFromList={onRemoveFromList}
          />
        )
      ) : (
        <>
          <Feature name={FEATURE_FLAGS.foamSharedListMessageTool}>
            {!!onMessageOpen && (
              <Button
                aria-label="Open message tool"
                iconStart="Envelope"
                size="lg"
                variant="secondary"
                onClick={() => onMessageOpen(creator)}
              >
                Ask a question
              </Button>
            )}
          </Feature>
          <ManagerDropdown
            manager={creator.manager as ManagerShortType}
            isShared={isShared}
          />
        </>
      )}
    </Box>
  </Flex>
);
